import React from 'react'

import { StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useContent } from '@sart/content'
import { adaptive } from '@sart/styles'
import {
  Title,
  Anchor,
  Description,
  Space
} from '@sart/components'

import NeedHelpFooter from './NeedHelpFooter'

export default function Unavailable(props) {

  const content = useContent()

  const { navigation } = props

  async function handleTryAgain() {
    navigation.navigate('Loading')
  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.wrapper}>
        <Space height={48} />

        <Title>{content.unavailable.title}</Title>

        <Space height={24} />

        <Description style={styles.description}>
          {content.unavailable.instructions}
        </Description>

        <Space height={48} />

        <Anchor title={content.unavailable.action} onPress={handleTryAgain} />
      </View>

      <NeedHelpFooter onPress={() => navigation.navigate('Help')} />
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  wrapper: {
    flex: 1,
    ...adaptive.wrapperPadding,
    justifyContent: 'center',
    alignItems: 'center'
  },
  description: {
    textAlign: 'center'
  }
})
